import { updatePassword } from '@basqet-dashboard/common/api';
import { Button, FormInput, SuccessModal } from '@basqet-dashboard/common/components';
import { securitySchema } from '@basqet-dashboard/common/utils';
import { TwoFactorAuthentication } from '@components';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const SecuritySettings = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({ mode: 'onChange', resolver: yupResolver(securitySchema) });

  const onSubmit = async (body) => {
    setIsLoading(true);
    try {
      await updatePassword(body);
      reset();
      setIsLoading(false);
      setShowModal(true);
    } catch (error) {
      const {
        response: {
          data: { message }
        }
      } = error;
      toast.error(message);
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className="card security">
        <h3 className="card__header">Change password</h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormInput
            label="Current password"
            placeholder="Enter your current password"
            name="current_password"
            type="password"
            error={errors.current_password && errors.current_password.message}
            {...register('current_password')}
          />
          <FormInput
            label="New password"
            placeholder="Enter your new password"
            name="new_password"
            type="password"
            error={errors.new_password && errors.new_password.message}
            {...register('new_password')}
          />
          <FormInput
            label="Confirm new password"
            placeholder="Confirm your new password"
            name="confirm_password"
            type="password"
            error={errors.confirm_password && errors.confirm_password.message}
            {...register('confirm_password')}
          />
          <Button isFull type="submit" isLoading={isLoading}>
            Update password
          </Button>
        </form>
      </div>
      {<TwoFactorAuthentication />}
      {showModal && (
        <SuccessModal
          onModalClose={() => setShowModal(false)}
          message="Your password has been updated successfully."
        />
      )}
    </>
  );
};

export { SecuritySettings };
